/**
 * @fileoverview Main application router component.
 */

import React from "react";
import {
  unstable_HistoryRouter as HistoryRouter,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import {SentryRoutes} from "../utils/sentryRoute";
import {FRONTEND_BASE_NAME} from "../config";

import {AdmissionRoutes} from "./AdmissionRoutes";
import {AdminRoutes} from "./AdminRoutes";
import {ADMISSION_WELCOME_ROUTE} from "../pages/page-admission-welcome/route";

import {PagePasswordChange} from "../pages/page-password-change";
import {PagePasswordReset} from "../pages/page-password-reset";
import {PageConfirmNewUser} from "../pages/page-confirm-new-user";
import {history} from "../utils/history";
import {LEGACY_ADMISSION_PATH, toWorkflowPath} from "./legacyAdmissionPath";

const LegacyAdmissionRedirect = () => {
  const location = useLocation();
  return (
    <Navigate
      to={{...location, pathname: toWorkflowPath(location.pathname)}}
      replace
    />
  );
};

/**
 * Main application router that handles all top-level routes.
 * Sets up the browser router with the frontend base name and custom history.
 *
 * @returns {JSX.Element} The main router component.
 */
export const AppRouter = () => (
  <HistoryRouter history={history} basename={FRONTEND_BASE_NAME}>
    <SentryRoutes>
      <Route path="/workflow/*" element={<AdmissionRoutes />} />
      <Route path="/admin/*" element={<AdminRoutes />} />
      <Route path="/request-reset-email" element={<PagePasswordReset />} />
      <Route path="/confirm-new-user/:token" element={<PageConfirmNewUser />} />
      <Route path="/confirm-password/:token" element={<PagePasswordChange />} />
      <Route
        path={`${LEGACY_ADMISSION_PATH}/*`}
        element={<LegacyAdmissionRedirect />}
      />
      <Route
        path="*"
        element={<Navigate to={ADMISSION_WELCOME_ROUTE} replace />}
      />
    </SentryRoutes>
  </HistoryRouter>
);
